import React, { useEffect, useState } from "react";
import BlockedIcon from "src/Assets/images/blockedIcon.png";
import upArrow from "src/Assets/images/UpButton.png";
import "./blockedCommunity.css";
import { Typography, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import API from "../../../../network";
import UnblockRequestModal from "./ReusableUnblockModal";

const Title = styled(Typography)({
  fontSize: "14px",
  fontWeight: "500",
});

const InviteStatus = styled(Typography)({
  fontSize: "13px",
  fontWeight: "500",
});

const SeeInviteButton = styled(Typography)({
  textAlign: "center",
  color: "#4795DE",
  fontSize: "14px",
  cursor: "pointer",
  margin: "auto !important",
  marginTop: "15px !important",
  fontWeight: "bold",
});

const BlockedCommunities = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [data, setData] = useState([]);
  const [blockedCommunityCoount, setBlockedCommunityCoount] = useState(0);
  const toggleList = () => {
    API.getBlockedCommunities()
      .then((res) => {
        setData(res?.data?.blockedCommunities);
        setBlockedCommunityCoount(res?.data?.blockedCommunitiesCount);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => toggleList(), []);
  return (
    <div>
      {!isExpanded && (
        <div className="AskActivity" onClick={() => setIsExpanded(true)}>
          <div className="usable-container">
            <img src={BlockedIcon} alt="Ask-icon" className="askicon" />
            <p className="ask mt-3">Blocked Communities</p>
          </div>
          <div className="usable-container">
            <span className="number ">{blockedCommunityCoount}</span>
            <img src={upArrow} alt="DownArrow" className="DownArrow" />
          </div>
        </div>
      )}
      {isExpanded && (
        <div className="AskActivity_active">
          <div
            className="color-combination"
            onClick={() => setIsExpanded(false)}
          >
            <div className="usable-container">
              <img src={BlockedIcon} alt="Ask-icon" className="askicon" />
              <p className="ask mt-3">Blocked Communities</p>
            </div>
            <div className="usable-container">
              <span className="number ">{data?.length}</span>
              <img src={upArrow} alt="DownArrow" className="DownArrow" />
            </div>
          </div>
          <div className=".blocked-community-postcard-main-container">
            {data?.length > 0 ? (
              data.map((item, index) => (
                <Tile
                  data={item}
                  key={`key-id-${item.id}`}
                  toggleList={toggleList}
                />
              ))
            ) : (
              <div className="no-data-container">
                <p>No blocked community available to show</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Tile = (props) => {
  const [isUnblockBtnClicked, setIsUnblockBtnClicked] = useState(null);

  const onCloseUnblockModal = () => {
    setIsUnblockBtnClicked(false);
  };

  const { userFollowCommunityName, blockedTime, unblockSentRequestTime } =
    props.data;

  return (
    <>
      <div className="blocked-community-postcard">
        <div style={{ display: "flex", marginBottom: "6px", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <Title>
              <span className="blocked-community-text">
                {userFollowCommunityName}
              </span>
            </Title>
            {unblockSentRequestTime !== "0" && (
              <p className="blocked-community-req-send-time-text">
                Unblock request sent {unblockSentRequestTime} ago
              </p>
            )}
          </div>
          <InviteStatus>
            <span className="blocked-community-time-text">
              {blockedTime} ago
            </span>
          </InviteStatus>
        </div>
        <Divider />
        <SeeInviteButton onClick={() => setIsUnblockBtnClicked(true)}>
          Unblock
        </SeeInviteButton>
      </div>
      <UnblockRequestModal
        onOpenUnblockReqModal={isUnblockBtnClicked}
        onCloseUnblockModal={onCloseUnblockModal}
        communityName={props?.data?.userFollowCommunityName}
        communityId={props?.data?.id}
      />
    </>
  );
};

export default BlockedCommunities;
